export default __webpack_public_path__ + "static/media/50.9cde51bd.jpg";